import { render, staticRenderFns } from "./InvoiceBankDetails.vue?vue&type=template&id=c4388c06&"
import script from "./InvoiceBankDetails.vue?vue&type=script&lang=js&"
export * from "./InvoiceBankDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports